<template>
  <div>
    <main>
      <div class="wrapper">
        <section class="header">
          <h1>We are dedicated to preserving our Pilates heritage.</h1>
          <img src="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about1@1x.jpg" srcset="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about1@2x.jpg 2x, https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about1@3x.jpg 3x" alt="Photo of Balanced Body engineering staff reviewing Contrology equipment" class="hero">
        </section>
        <section class="content">
          <p>With the Contrology suite of apparatus, we partnered with Jay Grimes, Karen Frischmann, Kathi Ross-Nash and others, to re-create all of the subtle functionality critical to the classical Pilates approach. We listened, learned, prototyped and tested. We looked at how the apparatus works, and how practitioners use it. Most critically, we examined the design details that had changed over time—and needed to be restored to bring back the original feel.</p>
          <p>The goal of our Contrology line is to replicate the original function, style and finish of the original Pilates equipment built in the early 1970’s. In order to do this, we have worked hard to source as many as the original materials and manufacturing techniques as possible.</p>
          <p>Our springs are made with the same details (neck-down, tapered ends, swivel hooks and open hooks), as the springs of that era. To be consistent, our Contrology springs are un-plated. In order to minimize oxidation, we recommend dry hands and avoiding areas with high humidity.</p>
          <p>Our aluminum Reformer bodies, and Cadillac bases are hand finished, raw aluminum selected for historical appearance and functionality.  The aluminum will darken with age. This is expected.  The aluminum can be cleaned with an alcohol-based hand sanitizer then coated with furniture polish or paste wax.</p>
          <p>Just like Joe, we use galvanized pipe for our Cadillac canopies.   Galvanizing is the process of applying a protective zinc coating to steel or iron, to help prevent rusting.  Galvanizing works great for rust but is not designed to be beautiful. Like aluminum it tends to darken inconsistently.  This is its natural condition.</p>
        </section>
        <section class="call-out-wrapper">
          <div class="call-out">
            <p>Additionally, our staff engineers have spent months analyzing original Pilates apparatus in order to re-create the original design details, including:</p>
            <p><b>Thin, high density, resilient foam</b> to provide maximum feedback for Users. The Contrology Reformer, Cadillac and Arm Chair all feature this signature foam. There is no extra cushioning and most authentically represents the “feel” provided in original Pilates apparatus.</p>
            <p><b>Pre-stretched &amp; pre-treated leather straps</b> hold their shape through continuous use and are conditioned with oil to last longer.</p>
            <div class="photos">
              <img src="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about2@1x.jpg" srcset="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about2@2x.jpg 2x, https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about2@3x.jpg 3x" alt="In-use photo of straps">
              <img src="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about3@1x.jpg" srcset="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about3@2x.jpg 2x, https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about3@3x.jpg 3x" alt="In-use photo of foot on cushion">
            </div>
            <p><b>Specially-engineered springs</b> have been relentlessly analyzed and tested to ensure they deliver the exact resistance of original springs. Each spring—for Reformer, Cadillac, Arm Chair and Ped-o-pul—has unique characteristics that give it the feel Users want. Our specially-developed “neck-down” design lengthens the life of spring by displacing the force over a wider area so there is no single point of weakness.</p>
            <!-- <p><b>Premium materials, attention-paid-to-details and craftsmanship</b> set Contrology apparatus apart. From vintage, forged steel eye-bolts on the Cadillac push-thru bar to cast aluminum shoulder supports and one-piece seamless side rails on the Reformer, and , it’s the details --- need additional details.</p> -->
            <div class="photos">
              <img src="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about4@1x.jpg" srcset="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about4@2x.jpg 2x, https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about4@3x.jpg 3x" alt="Product close-up of Cadillac legs">
              <img src="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about5@1x.jpg" srcset="https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about5@2x.jpg 2x, https:///s3.amazonaws.com/s3.pilates.com/contrology/contrology-about5@3x.jpg 3x" alt="Product close-up of Reformer springs">
            </div>
          </div>
        </section>
        <section class="content">
          <p>With the blessings of our classical colleagues, we are proud to present our Contrology Suite of Apparatus.  We look forward to you trying and testing each piece, and <a href="mailto:social@pilates.com" title="Share your experience">hope you will share your experiences with us</a>.</p>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    name: "about",

    metaInfo: {
      title: "About Contrology Pilates - What is Contrology - Pilates History",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Discover how the Contrology suite of pilates apparatus was created & the important partnerships we had in making them as authentic as possible. Learn more."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-about1@1x.jpg"
        }
      ]
    }
  }
</script>

<style lang="scss" scoped>
.header,
.content {
  max-width: 850px;
  margin: 0 auto;
}

.call-out {
  max-width: 750px;
  margin: 0 auto;
}

.hero {
  width: 100%;
  margin: 20px 0;
}

.content p {
  font-family: var(--noto);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 300;
  color: var(--black);
  margin-bottom: 1.8em;
}

.content a {
  color: var(--black);
}

.call-out-wrapper {
  width: calc(100% + 40px);
  margin: 45px 0 45px -20px;
  padding: 48px 20px 15px;
  background-color: rgba(255, 255, 255, 0.85);
  max-width: none;
}

.call-out {
  font-family: var(--roboto);
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: 400;
  color: var(--black);
}

.call-out p {
  margin: 0 0 25px;
}

.photos {
  margin: 50px 0;
}

.photos img {
  display: block;
  width: 100%;
  margin: 3px 0;
}

@media only screen and (min-width: 768px) {
  h1 {
    text-align: left;
    font-size: 2.4rem;
  }

  .hero {
    margin: 0 0 30px;
  }

  .content p {
    font-size: 1.25rem;
    line-height: 1.3;
  }

  .call-out-wrapper {
    padding: 60px 20px 20px;
  }

  .photos {
    display: flex;
    flex-flow: row nowrap;
  }

  .photos img {
    width: 50%;
    object-fit: contain;
    margin: 0 2px;
  }
}
</style>